import { COURSES_TYPES } from '@/constants/courses';

export const getCoursePageTitle = (
  type: string,
  translations: Record<string, string>
): string => {
  switch (type) {
    case COURSES_TYPES.FULLSTACK:
      return translations.chooseCareerTitle;
    case COURSES_TYPES.ONDEMAND:
      return translations.chooseOnDemandCourseTitle;
    case COURSES_TYPES.LIVE_COURSES:
      return translations.chooseLiveCourseTitle;
    default:
      return translations.chooseCareerTitle;
  }
};
